import { ErrorState } from '@/components/ui/ErrorState';
import { StatCard, StatCardRow } from '@/components/ui/StatCard';
import { formatCount } from '@/lib/numbers';

import { ARRIVES_WITH_INVITATIONS, DASH } from './supporterLabels';
import { useSupporterSummary } from './useSupporters';

/**
 * The four cards (P2). They read the summary route and nothing else: no list
 * reply and no search reaches them, so they hold still while the person types
 * (I2, backend D9). Pending Invitations has no number until member
 * invitations exist, and says so rather than showing a made-up zero.
 *
 * One failure is one error with a retry in the row's place, not four broken
 * cards, and leaves the table beneath standing (P8, NF2).
 */
export function SupporterSummaryCards() {
  const summary = useSupporterSummary();

  if (summary.isError) {
    return (
      <ErrorState
        title="The supporter totals could not be loaded."
        onRetry={() => void summary.refetch()}
        testId="supporters-summary"
      />
    );
  }

  const loading = summary.isPending;
  const count = (n: number | undefined) => (n === undefined ? '' : formatCount(n));

  return (
    <StatCardRow label="Supporter totals" testId="supporters-summary-group">
      <StatCard
        label="Total Supporters"
        value={count(summary.data?.total)}
        caption="Followed and invited"
        loading={loading}
        testId="supporters-total-card"
      />
      <StatCard
        label="Followed"
        value={count(summary.data?.supporters)}
        caption="Follow your organization in the app"
        loading={loading}
        testId="supporters-followed-card"
      />
      <StatCard
        label="Invited"
        value={count(summary.data?.members)}
        caption="Joined by invitation"
        loading={loading}
        testId="supporters-invited-card"
      />
      <StatCard
        label="Pending Invitations"
        value={DASH}
        caption={ARRIVES_WITH_INVITATIONS}
        testId="supporters-pending-card"
      />
    </StatCardRow>
  );
}
